import { removeMetricFilter } from '@store/trends/base/actions';
import { setSlice, enableTableCompare } from '@store/trends/birdChart/actions';
import { useSetAtom } from 'jotai';
import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { sliceAreaAtom, zoomAreaAtom } from '../atoms';
import { METRIC_FILTER_TYPES } from '../utils/metricFilterUtils';

// used for resettig zoom/slice state on double click
function useZoomOut({ instance, enabled }) {
  const dispatch = useDispatch();

  const setZoomArea = useSetAtom(zoomAreaAtom);
  const setSliceArea = useSetAtom(sliceAreaAtom);

  // handle chart zoom action
  const handleZoom = useCallback(
    (zoomValue) => {
      if (instance) {
        instance.dispatchAction({
          type: 'dataZoom',
          ...zoomValue,
        });

        // clear brush selection
        instance.dispatchAction({
          type: 'brush',
          command: 'clear',
          areas: [],
        });
      }
    },
    [instance],
  );

  // double click handler
  const handleDblClick = useCallback(() => {
    // intial state
    const zoomValue = { start: 0, end: 100 };
    const area = [];
    const range = [0, 0];

    const option = instance.getOption();
    const metric = option._chartMetric;

    // reset zoom level
    if (option._viewType === 'timeseries') {
      setZoomArea(zoomValue);
      setSliceArea(area);
      dispatch(setSlice([0, 100], range));
      dispatch(enableTableCompare(false));
    } else {
      handleZoom(zoomValue);
      // removing bound type metric filter
      dispatch(removeMetricFilter({ metric, meta: { type: METRIC_FILTER_TYPES.bound } }));
    }
  }, [instance, handleZoom]);

  // register chart events
  useEffect(() => {
    if (instance) {
      if (enabled) {
        // double click to undo zoom
        // getZr will capture dblclick from whole canvas
        instance.getZr().on('dblclick', handleDblClick);
      }
      // off on unmount
      return () => {
        instance.getZr().off('dblclick', handleDblClick);
      };
    }
  }, [handleDblClick, instance, enabled]);
}

export default useZoomOut;
